import { OrderPage_GetExistingOrderQuery } from "../../../codegen/graphql";
import { ProcessRow } from "../Processes/ProcessRow";


export default function OrderPageProcesses({
  orderData,
}: {
  orderData: NonNullable<OrderPage_GetExistingOrderQuery['order']>;
}) {
  const processes = orderData.processes;
  if (!processes || processes.length === 0) {
    return (
      <div className="px-6 py-8 text-center text-gray-500">
        No processes found for this order.
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
      {/* Header Row */}
      <div className="grid grid-cols-12 bg-gray-50 border-b border-gray-200">
        <div className="col-span-4 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          Process Name
        </div>
        <div className="col-span-2 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          Status
        </div>
        <div className="col-span-2 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          Created At
        </div>
        <div className="col-span-2 px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
          Duration
        </div>
        <div className="col-span-2 px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
          Actions
        </div>
      </div>

      {/* Data Rows */}
      <div className="bg-white">
        {!orderData.processes || orderData.processes.length === 0 ? (
          <div className="px-6 py-8 text-center text-gray-500">
            No processes found for this order.
          </div>
        ) : (
          orderData.processes.map((process) => (
            <ProcessRow
              key={process.id}
              process={process}
              level={0}
            />
          ))
        )}
      </div>
    </div>
  );
}